import { render, staticRenderFns } from "./CalendarCrud.vue?vue&type=template&id=28e0044e"
import script from "./CalendarCrud.vue?vue&type=script&lang=js"
export * from "./CalendarCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports